<div [ngClass]="{'form-layout-compact': useCompactFormLayout}">
    <div class="field">
        <label [required]="true" soho-label for="lm-add-total-total-type">{{ 'SummaryTotalOperator' | translate}}</label>
        <select data-automation-id="lm-add-total-total-type"
            soho-dropdown
            noSearch
            id="lm-add-total-total-type"
            name="lm-add-total-total-type"
            [(ngModel)]="totalType">
                <option [value]="'max'">{{ 'SummaryMaxOperator' | translate}}</option>
                <option [value]="'min'">{{ 'SummaryMinOperator' | translate}}</option>
                <option [value]="'avg'">{{ 'SummaryAvgOperator' | translate}}</option>
                <option [value]="'sum'">{{ 'SummarySumOperator' | translate}}</option>
                <option [value]="'instance count'">{{ 'SummaryInstanceCountOperator' | translate}}</option>
        </select>
    </div>
    <div [ngClass]="this.totalType !== 'instance count' ? 'field' : 'lm-hide'">
        <label soho-label class="required" for="lm-add-total-field">{{ 'ColumnEditorFieldLabel' | translate}}</label>
        <input data-automation-id="lm-add-total-field"
            class="padding"
            name="lm-add-total-field"
            id="lm-add-total-field"
            soho-alert
            soho-autocomplete
               [source]="autoCompleteSource"
               [filterMode]="null"
               [delay]="400"
            (focusout)="validateField()"
            [(ngModel)]="totalField"
    >
    <button class="btn-primary" data-automation-id="lm-add-total-field-picker-anchor"
       (click)="openFieldPicker()">{{ 'AdvancedSearchLabel' | translate }}</button>
    </div>
    <div class="flex-row-container">
        <div class="field padding">
            <input data-automation-id="lm-add-total-use-explicit-label"
                   soho-checkbox
                   type="checkbox"
                   class="checkbox"
                   id="lm-add-total-use-explicit-label"
                   [(ngModel)]="useExplicitLabel">
            <label soho-label for="lm-add-total-use-explicit-label" [forCheckBox]="true">{{ 'ExplicitLabel' | translate }}</label>
        </div>
        <div *ngIf="useExplicitLabel" class="field">
            <input data-automation-id="lm-add-total-explicit-label"
                   noSearch
                   spellcheck="false"
                   id="lm-add-summary-total-label"
                   name="lm-add-summary-total-label"
                   [(ngModel)]="explicitLabel">
        </div>
        <div *ngIf="!useExplicitLabel" class="field">
            <label data-automation-id="lm-add-total-explicit-label-info-text">{{ 'LabelDefaultsToFieldName' | translate }}</label>
        </div>
    </div>
</div>